import { useCreateDashboardFolderModalModel } from './create-dashboard-folder-modal.model'
import type { ICreateDashboardFolderModal } from './create-dashboard-folder-modal.types'
import { CreateDashboardFolderModalView } from './create-dashboard-folder-modal.view'

export const CreateDashboardFolderModal = ({ isOpen }: ICreateDashboardFolderModal) => {
  const createDashboardFolderModalModel = useCreateDashboardFolderModalModel()
  return <CreateDashboardFolderModalView isOpen={isOpen} {...createDashboardFolderModalModel} />
}
